<template>
  <div class='InputPwRecovery'>
    <div v-if="!load" class="ask-input-btn">
      <div class="desc">Crie uma nova senha de usuário</div>
      <div class="cont-input">
        <input @input="errMsg=''" v-model="senha" type="password" placeholder="Nova senha">
      </div>
      <div class="cont-input">
        <input @input="errMsg=''" v-model="csenha" type="password" placeholder="Confirmar nova senha">
      </div>
      <div class="cont-btn">
        <button @click="run">salvar</button>
      </div>
      <div class="err-msg">{{ errMsg }}</div>
    </div>
    <div v-if="load">
      <vue-spinner size="40px"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VueSpinner } from 'vue3-spinners'
import { useVuelidate } from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'InputPwRecovery',
  components: { VueSpinner },
  data () {
    return {
      senha: '',
      csenha: '',
      errMsg: '',
      load: false
    }
  },
  validations () {
    return {
      senha: {
        required,
        minLength: minLength(6)
      },
      csenha: {
        sameAs: (s) => s === this.senha
      }
    }
  },
  computed: {
    ...mapGetters(['PWrecovery'])
  },
  methods: {
    ...mapActions(['_UpdatePw']),
    async run () {
      if(!await this.v$.$validate()) {
        if(this.v$.senha.required.$invalid) {
          this.errMsg = 'O campo nova senha é obrigatório'
          return
        }
        if(this.v$.senha.minLength.$invalid) {
          this.errMsg = 'O campo nova senha deve ter no mínimo 6 caracteres'
          return
        }
        if(this.v$.csenha.sameAs.$invalid) {
          this.errMsg = 'As senhas devem ser iguais'
          return
        }
      }
      this.load = true
      setTimeout(() => {
        this._UpdatePw({ email: this.PWrecovery.email, codigo: this.PWrecovery.codigo, senha: this.senha })
          .then(res => {
            if(res.status) {
              this.$router.push('/pwrecovery/success')
              return
            }
            this.load = false
            this.errMsg = res.message
          })
      }, 2000)
    }
  }
}
</script>

<style scoped>
.InputPwRecovery {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.cont-input {
  padding-top: 4%;
}

.desc {
  width: 410px;
}

input {
  border: thin solid #CCCCCC;
  border-radius: 5px;
  font-size: 18px;
  width: 250px;
  padding: 2%;
}

.cont-btn {
  padding-top: 4%;
}

button {
  border: 0;
  width: 268px;
  height: 30px;
  cursor: pointer;
  background-color: #333333;
  color: #EEEEEE;
  font-size: 14px;
  border-radius: 5px;
}

button:hover {
  background-color: #4E4A4A;
}

.err-msg {
  width: 268px;
  height: 30px;
  margin: auto;
  margin-top: 10px;
  color: #6E2E2F;
  font-size: 14px;
}
</style>
